export const services = {
  label: 'Services & Tools',
  heading: 'Services & Tools We Offer',
  intro:
    'Social media, various management tools, and community features will be released here progressively. Click "View Details" to see the details of each service.',
  comingSoonTitle: 'More services and tools in preparation',
  comingSoonBody:
    'EachTeach plans to continuously add new tools and resources. Join the community to receive the latest updates.',

  // ServiceCard
  card: {
    showDetail: 'View Details',
    close: 'Close',
    openLink: 'Open Link',
  },
};
